/*
 * practitioner-availability (schema)
 */
import { boolean, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { practitioners } from "../practitioner/practitioner.schema"
import { users } from "../user/user.schema"

export const practitionerAvailabilities = schema.table(
	"practitioner_availabilities",
	{
		id: uuid("id").primaryKey().notNull().defaultRandom(),

		// --- Relations ---
		practitionerId: uuid("practitioner_id")
			.notNull()
			.references(() => practitioners.id, { onDelete: "cascade" }),

		// --- Time (always UTC; timezone is the IANA name used when created) ---
		startsAt: timestamp("starts_at", { withTimezone: true }).notNull(),
		endsAt: timestamp("ends_at", { withTimezone: true }).notNull(),
		timezone: varchar("timezone", { length: 64 }).notNull().default("UTC"),

		// --- Grouping (all slots from one range-creation share a batchId) ---
		batchId: uuid("batch_id"),

		notes: text("notes"),

		// --- System ---
		active: boolean("active").notNull().default(true),
		createdAt: timestamp("created_at", { withTimezone: true })
			.notNull()
			.defaultNow(),
		updatedAt: timestamp("updated_at", { withTimezone: true })
			.notNull()
			.defaultNow(),
		createdBy: uuid("created_by").references(() => users.id, {
			onDelete: "set null",
		}),
		updatedBy: uuid("updated_by").references(() => users.id, {
			onDelete: "set null",
		}),
	},
)
